// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FrBW","icon":"styles_icon__33C6c"};